<!-- BANNER -->
<div class="mobile-header">
  <a class="back-btn text-white" [routerLink]="['/']">
    <i class="material-icons">arrow_back_ios</i>
  </a>
  <h5 class="title">{{ 'faq.page.title' | translate }}</h5>
</div>

<div class="container">
  <!--FAQs-->
  <fgbcl-faq-section></fgbcl-faq-section>

  <!--No results-->
  <ng-container *ngIf="showPlaceholder$ | async">
    <div class="no-items no-results-placeholder-div d-flex align-items-center justify-content-center text-center">
      <div class="no-results-placeholder">
        {{ 'faq.placeholder.description' | translate: { fgbdefault: 'There are no FAQs available at the moment.' } }}
      </div>
    </div>
  </ng-container>
</div>
